import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";


export const passwordMatchingValidatior: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const password = control.get('newPassword');
  const passwordRepeat = control.get('newPasswordRepeat');

  return password?.value === passwordRepeat?.value ? null : { notmatched: true };
};
